export const JWM_CONTAINER = 'jwm-container';
